export const DATE_FORMAT = 'YYYY-MM-DD';
export const DB_DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const READABLE_DATE_FORMAT = 'DD-MM-YYYY';
export const READABLE_TIME_FORMAT = 'HH:mm:ss';

export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const TIMESTAMP_FORMAT = `${DATE_TIME_FORMAT}.SSS`;

export const READABLE_DATE_TIME_FORMAT = `${READABLE_DATE_FORMAT} ${READABLE_TIME_FORMAT}`;
